var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 9"}},[_c('g',[_c('g',[_c('path',{attrs:{"d":"M5.156 8.888V7.544h2.688v1.344zM.5.888h12v1.344H.5zm2 4.656V4.23h8v1.313z"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }